// Per-metric toggle pair (14 Tage / Trend) rendered on each data card in
// MonitoringAnalysisPanel — builds up the ContextOption[] selection for one ValueType
// that formatMonitoringContext.ts filters by on the backend.
import { ContextOption } from "pokal_api"

type Props = {
    active: ContextOption[]
    onChange: (active: ContextOption[]) => void
}

const CHIPS: { option: ContextOption; label: string }[] = [
    { option: "14days", label: "14 Tage" },
    { option: "trend", label: "Trend" },
]

export default function ContextChips({ active, onChange }: Props) {
    function toggle(option: ContextOption) {
        if (active.includes(option)) {
            onChange(active.filter(o => o !== option))
        } else {
            onChange([...active, option])
        }
    }

    return (
        <div className="flex gap-1 flex-wrap mt-1">
            {CHIPS.map(({ option, label }) => {
                const isActive = active.includes(option)
                return (
                    <button
                        key={option}
                        onClick={e => { e.stopPropagation(); toggle(option) }}
                        className={
                            isActive
                                ? "bg-teal-100 border border-teal-400 text-teal-700 text-xs px-2 py-0.5 rounded font-medium"
                                : "bg-white border border-gray-300 text-gray-500 text-xs px-2 py-0.5 rounded hover:border-teal-400 hover:text-teal-600"
                        }
                    >
                        {label}
                    </button>
                )
            })}
        </div>
    )
}
